import React, { useState } from 'react'
import { Link, Text } from '@contrast-security-inc/design-system-typography'
import { useIntl } from 'react-intl'
import {
  Modal,
  ModalBody,
  ModalFooter
} from '@contrast-security-inc/design-system-popovers'
import { IconHelp } from '@contrast-security-inc/design-system-foundations'
import { Button } from '@contrast-security-inc/design-system-buttons'
import { css } from '@emotion/css'
import { formatStyles } from '../react-intl-helpers'

export function ServerSummaryLegend() {
  const { formatMessage } = useIntl()

  const [showModal, setShowModal] = useState(false)

  const toggle = () => setShowModal(!showModal)
  const close = () => setShowModal(false)

  return (
    <>
      <Text
        className={css`
          margin-bottom: 16px;
          display: block;
        `}
      >
        {formatMessage(
          {
            id: 'detail_servers_summaryLegend'
          },
          {
            learnMoreLink: (
              <Link testId="server-summary-legend-link" onClick={toggle}>
                {formatMessage({ id: 'action_learnMore' })}
              </Link>
            )
          }
        )}
      </Text>
      {showModal && (
        <Modal
          testId="server-summary-legend-modal"
          onClose={close}
          isOpen={true}
          Icon={IconHelp}
          size="md"
          title={formatMessage({ id: 'title_summary' })}
          variant="info"
        >
          <ModalBody>
            <div
              className={css`
                display: flex;
                flex-direction: column;
              `}
            >
              <Text font="body">
                {formatMessage({
                  id: 'detail_servers_summary_featureConfigModal_p1'
                })}
              </Text>
              <RowSeparator />

              <Text font="body">
                {formatMessage({
                  id: 'detail_servers_summary_featureConfigModal_p2_li1'
                })}
              </Text>
              <Text font="body">
                {formatMessage({
                  id: 'detail_servers_summary_featureConfigModal_p2_li2'
                })}
              </Text>
              <Text font="body">
                {formatMessage({
                  id: 'detail_servers_summary_featureConfigModal_p2_li3'
                })}
              </Text>
              <Text font="body">
                {formatMessage({
                  id: 'detail_servers_summary_featureConfigModal_p2_li4'
                })}
              </Text>
              <Text font="body">
                {formatMessage({
                  id: 'detail_servers_summary_featureConfigModal_p2_li5'
                })}
              </Text>
              <Text font="body">
                {formatMessage({
                  id: 'detail_servers_summary_featureConfigModal_p2_li6'
                })}
              </Text>
              <RowSeparator />

              <Text font="body">
                {formatMessage(
                  {
                    id: 'detail_servers_summary_featureConfigModal_p3'
                  },
                  {
                    orderOfPrecedenceLink: (
                      <Link
                        testId="server-summary-legend-modal-doc-link"
                        isExternal
                        href={formatMessage({
                          id: 'detail_servers_summary_featureConfigModal_p3_link_value'
                        })}
                      >
                        {formatMessage({
                          id: 'detail_servers_summary_featureConfigModal_p3_link'
                        })}
                      </Link>
                    )
                  }
                )}
              </Text>
              <RowSeparator />

              <Text font="body">
                {formatMessage(
                  {
                    id: 'detail_servers_summary_featureConfigModal_p4'
                  },
                  {
                    ...formatStyles.bold
                  }
                )}
              </Text>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button variant="secondary" onClick={close}>
              {formatMessage({ id: 'action_close' })}
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  )
}

export const RowSeparator = () => (
  <div
    data-testid="server-summary-legend-modal-row-separator"
    className={css`
      height: 24px;
    `}
  ></div>
)
